import API from "../util/api";
export const getTransactions = async (params) => {
  let data = null;

  await API.get('/commission-transactions', {params})
    .then(res => {
      data = res.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}

export const getCommissionBalanceInfo = async (params) => {
  let data = null;

  await API.get('/commission-balance-info', {params})
    .then(res => {
      data = res.data;
    })
    .catch((err) => {
      throw new Error(JSON.stringify(err.response.data))
    });

  return data;
}

export const storeWithdrawRequest = async (payload) => {
  let data = null;
  await API.post('/store-commission-withdraw-request', payload)
      .then(res => {
        data = res.data.data;
      })
      .catch((err) => {
        throw new Error(JSON.stringify(err.response.data))
      });

  return data;
}